module.exports = require("@tiptap/extension-table-header");